import type { ReactNode } from 'react';
import { CouponCard } from './CouponCard';
import type { CustomerClaimDiscount } from './customerClaimDiscount';

type CouponCardTranslations = {
  used: string;
  activated: string;
  amount: string;
  discount: string;
  free: string;
};

type Props = {
  title: string;
  subtitle: string;
  discounts: CustomerClaimDiscount[];
  action?: ReactNode;
  translations?: CouponCardTranslations;
};

export function ReferralCustomerView({ title, subtitle, discounts, action, translations }: Props) {
  return (
    <div className='flex min-w-0 flex-col gap-4'>
      <div className='flex min-w-0 flex-col gap-2 text-balance'>
        <h1 className='text-3xl font-bold break-words text-primary md:text-4xl'>{title}</h1>
        <p className='text-balance break-words'>{subtitle}</p>
      </div>
      {discounts.map((discount) => (
        <CouponCard
          key={discount.id}
          namePublic={discount.namePublic}
          descriptionPublic={discount.descriptionPublic}
          discountAmount={discount.discountAmount}
          currency={discount.currency}
          discountPercentage={discount.discountPercentage}
          translations={translations}
        />
      ))}
      {action}
    </div>
  );
}
